import { render, staticRenderFns } from "./pi-card.vue?vue&type=template&id=de6b2a80&"
import script from "./pi-card.vue?vue&type=script&lang=ts&"
export * from "./pi-card.vue?vue&type=script&lang=ts&"
import style0 from "./pi-card.vue?vue&type=style&index=0&id=de6b2a80&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports